/*
 * WYBE performance layer
 * Safe, progressive enhancements only. No visual redesign.
 */
(() => {
  'use strict';

  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1));

  const isSameOriginPage = (url) => {
    try {
      const u = new URL(url, location.href);
      return u.origin === location.origin &&
        (u.pathname === '/' || /\/(products|collections|pages|blogs|blog|search)(\/|$)/.test(u.pathname));
    } catch (_) {
      return false;
    }
  };

  const prefetchPage = (href) => {
    if (!isSameOriginPage(href)) return;
    const url = new URL(href, location.href).href;
    if (document.head.querySelector(`link[rel="prefetch"][href="${CSS.escape(url)}"]`)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.fetchPriority = 'low';
    document.head.appendChild(link);
  };

 
  const prepareImages = () => {
    document.querySelectorAll('img').forEach((img) => {
      if (!img.hasAttribute('decoding')) {
        img.decoding = 'async';
      }
    });
  };


  const bindIntentPrefetch = () => {
    if (window.matchMedia('(pointer: coarse)').matches) return;

    document.addEventListener('pointerover', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.pointerType !== 'mouse') return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      if (link.dataset.noPrefetch !== undefined) return;
      prefetchPage(link.href);
    }, { passive: true });
  };

 

  const warmProductGallery = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer"]');
      if (!viewer || gallery.dataset.wybeGalleryWarm) return;
      gallery.dataset.wybeGalleryWarm = 'true';

      const warm = () => {
        const slides = Array.from(viewer.querySelectorAll('[data-media-id]'));
        if (!slides.length) return;
        const active = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const indexes = [active, active + 1, active - 1].filter((i) => i >= 0 && i < slides.length);

        indexes.forEach((i) => {
          slides[i].querySelectorAll('img').forEach((img) => {
            if (img.currentSrc || img.src) {
              img.loading = 'eager';
              img.decoding = 'async';
            }
          });
        });
      };

      gallery.addEventListener('pointerdown', warm, { passive: true });
      gallery.addEventListener('touchstart', warm, { passive: true });
    });
  };

 

  const init = () => {
    prepareImages();
    bindIntentPrefetch();
    warmProductGallery();

    // Let the browser finish critical rendering before doing the second pass.
    idle(() => prepareImages(), { timeout: 1200 });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Shopify section rendering can add new images/sliders after initial load.
  document.addEventListener('shopify:section:load', () => {
    idle(() => {
      prepareImages();
      warmProductGallery();
    });
  }, { passive: true });
})();
